import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { EditorProps } from '@progress/kendo-react-editor';

interface ToggleHtmlViewProps extends EditorProps {
  isHtmlView: boolean;
  onToggle: () => void;
}

export const ToggleHtmlView: React.FC<ToggleHtmlViewProps> = ({
  isHtmlView,
  onToggle
}) => {
  return (
    <Button
      togglable={true}
      selected={isHtmlView}
      onClick={onToggle}
      title={isHtmlView ? 'Off HTML view' : 'HTML view'}>
      <span
        className="material-symbols-outlined"
        style={{
          fontSize: '20px'
        }}>
        {isHtmlView ? 'code' : 'code_off'}
      </span>
    </Button>
  );
};
